<template>
  <div>
    <div>
      <v-flex justify="center">
        <!-- <NewMapping v-if="selectedStudent!=null" schoolId="schoolID" id="id"  v-model="dialog"   :student="selectedStudent" /> -->
        <NewMapping v-model="dialog" />
      </v-flex>
    </div>
    <div>
      <v-card class="mx-auto" max-width="1000" min-width="300">
        <v-toolbar class="pencil" :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-expand-transition>
          <div v-if="Hide">
            <div v-if="Mappings.length!=0">
            <v-toolbar :color="ToolColor.slice(0, -1)+'3'" dark @click="HideOngoing = !HideOngoing">
              <v-toolbar-title>Pågående</v-toolbar-title>

              <v-toolbar-side-icon color="white darken-1">
                <v-icon v-if="HideOngoing == false" color="orange ligthen-1"
                  >arrow_downward</v-icon
                >
                <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
              </v-toolbar-side-icon>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-expand-transition>
              {{Mappings}}
              <div v-if="HideOngoing">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex
                      v-for="item in Mappings.filter(
                        (Map) => Map.deadline >= Date.now()
                      )"
                      md6
                      lg4
                      xs12
                      :key="item.name"
                    >
                      <Mapcard ToolColor="green lighten-4" :item="item" />
                    </v-flex>

           
                             </v-layout>
                </v-container>
                   <v-btn
                xs3
                class="mx-2"
                dark
                @click="dialog = true"
                color="green ligthen-2"
              >
                Skapa ny kartläggning
              </v-btn>   
              </div>
            </v-expand-transition>

           <v-toolbar :color="ToolColor.slice(0, -1)+'4'" dark @click="HideDeadline = !HideDeadline">
              <v-toolbar-title>Passerat deadline:</v-toolbar-title>

              <v-toolbar-side-icon color="white darken-1">
                <v-icon v-if="HideDeadline == false" color="orange ligthen-1"
                  >arrow_downward</v-icon
                >
                <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
              </v-toolbar-side-icon>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-expand-transition>
              <div v-if="HideDeadline">

            <v-container grid-list-md>

              <v-layout row wrap>
                <v-flex
                  v-for="item in Mappings.filter(
                    (Map) => Map.deadline < Date.now()
                  ).filter(
                    (Map) => !Map.hasOwnProperty('archive')
                  )"
                  md6
                  lg4
                  xs12
                  :key="item.name"
                >
                  <Mapcard ToolColor="blue darken-2" :item="item" />
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-expand-transition>

    <v-toolbar :color="ToolColor.slice(0, -9)+'darken-1'" dark @click="HideArchive = !HideArchive">
              <v-toolbar-title>Arkiverad:</v-toolbar-title>

              <v-toolbar-side-icon color="white darken-1">
                <v-icon v-if="HideArchive == false" color="orange ligthen-1"
                  >arrow_downward</v-icon
                >
                <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
              </v-toolbar-side-icon>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-expand-transition>
              <div v-if="HideArchive">

            <v-container grid-list-md>
              <h1></h1>

              <v-layout row wrap>
              <v-flex
                  v-for="item in Mappings.filter(
                    (Map) => Map.hasOwnProperty('archive')
                  )"
                  md6
                  lg4
                  xs12
                  :key="item.name"
                >
                  <Mapcard ToolColor="red darken-2" :item="item" />
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-expand-transition>
        
          </div>
             <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns inga kartläggningar just nu.</span>
          <v-btn @click="dialog=true" dark color="green ligthen-1">
    Skapa kartläggning
  </v-btn>
    </div>
          </div>
          
        </v-expand-transition>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NewMapping from "./NewMapping";
import Mapcard from "./Mapcard";

export default {
  components: { NewMapping, Mapcard },
  props: {
    Headline: String,
    ToolColor: String,
    schoolId: String
  },
  computed: {
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId"]),
    // ...mapGetters('classesAP', ['classes']),
    ...mapGetters("mappings", ["Mappings","mappingsFetched"]),
  },
  created() {},
  methods: {
    ...mapActions('mappings', ['initMappings']),

    Loadin()
    {
    if (this.mappingsFetched==false) {
      //console.log("Fetched");   
         this.initMappings(this.schoolId)
}  
    },

  },
  data() {
    return {
      selectedStudent: null,
      Hide: false,
      dialog: false,
      HideOngoing: true,
      HideDeadline: true,
      HideArchive: false,


    };
  },
};
</script>

<style scoped>
</style>